/**
 * @generated SignedSource<<1dbb769605279d85d504ab0c280be0f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteSplitRequestInput = {
  splitRequestId: string;
};
export type DeleteSplitRequestMutation$variables = {
  input: DeleteSplitRequestInput;
};
export type DeleteSplitRequestMutation$data = {
  readonly deleteSplitRequest: {
    readonly deletedSplitRequestId: string | null | undefined;
  } | null | undefined;
};
export type DeleteSplitRequestMutation = {
  response: DeleteSplitRequestMutation$data;
  variables: DeleteSplitRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteSplitRequestPayload",
    "kind": "LinkedField",
    "name": "deleteSplitRequest",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedSplitRequestId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteSplitRequestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteSplitRequestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "46dfef38ced01fd4250d5295ac1aee2a",
    "id": null,
    "metadata": {},
    "name": "DeleteSplitRequestMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteSplitRequestMutation(\n  $input: DeleteSplitRequestInput!\n) {\n  deleteSplitRequest(input: $input) {\n    deletedSplitRequestId\n  }\n}\n"
  }
};
})();

(node as any).hash = "bb0dc8ab5e25bb232a538b66f686da1c";

export default node;
